import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SHOW_HIDE_MEMBERSHIP_CARD, SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS, SHOW_HIDE_MEMBERSHIP_CARD_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getShowHideMembershipCard({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId, membershipId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/activity/${membershipId}/show-confidential-data`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SHOW_HIDE_MEMBERSHIP_CARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SHOW_HIDE_MEMBERSHIP_CARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SHOW_HIDE_MEMBERSHIP_CARD_ERROR, payload: error });
  }
}

export function* watchShowHideMembershipCard() {
  yield takeEvery(SHOW_HIDE_MEMBERSHIP_CARD, getShowHideMembershipCard);
}

function* watchShowHideMembershipCardSaga() {
  yield all([fork(watchShowHideMembershipCard)]);
}

export default watchShowHideMembershipCardSaga;
